import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const OperatorPlatformTrunkPrefix = ({
    darkMode,
    errors,
    touched,
    ...props
}) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.trunkSegment && touched.trunkSegment}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Trunk Prefix <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Alphanumeric only (2-8 characters)
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="trunkSegment"
                            name="trunkSegment"
                            onChange={props.onChange}
                            validate={(value) => {
                                if (!value) return 'Trunk Prefix is required';
                                if (!/^[A-Za-z0-9]+$/.test(value))
                                    return 'Trunk Prefix must be alphanumeric only';
                                if (value.length < 2 || value.length > 8)
                                    return 'Trunk Prefix must be 2-8 characters';
                            }}
                            error={errors.trunkPrefix}
                            {...props}
                        />
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Alphanumeric only (2-8 characters)"
                        ariaLabel="operator-platform-trunk-prefix-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OperatorPlatformTrunkPrefix;
